import { render, staticRenderFns } from "./GoodPracticeDetailPage.vue?vue&type=template&id=f008779e&scoped=true"
import script from "./GoodPracticeDetailPage.vue?vue&type=script&lang=js"
export * from "./GoodPracticeDetailPage.vue?vue&type=script&lang=js"
import style0 from "./GoodPracticeDetailPage.vue?vue&type=style&index=0&id=f008779e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f008779e",
  null
  
)

export default component.exports